<template>
  <section class="custom_page_v2 mobile_div section_bg first_page section">
    <div class="section_header mobile_div d-flex justify-content-center" v-if="is_load">
      <nav aria-label="breadcrumb"   >
        <ol class="breadcrumb">

          <li class="breadcrumb-item"><router-link tag="a" :to="{name: 'leads'}">
            Все сделки
          </router-link></li>


          <li class="breadcrumb-item active" aria-current="page">Новая сделка</li>
        </ol>
      </nav>
    </div>
    <div class="section_black mobile_div">
      <loading-block v-if="is_load==false && is_load_error==false" :loading="!is_load"/>
      <div class="container-fluid" v-if="is_load==false && is_load_error==true">
        <div class="alert alert-warning">
          <h2>Ошибка</h2>
            <p>{{ load_error}}</p>
        </div>

      </div>
      <div class="" v-if="is_load">
      <div class="section_header nocenter mobile_div">
        <h4 class="text-center">Добавить сделку</h4>
        <div class="container-fluid">

          <div class="form-group">
            <label for="exampleCategoryitem">Воронка </label>
            <select id="exampleCategoryitem" v-model="newLead.funnel_id" required
                class="form-control">

              <option  v-for="funnel in funnels" :value="funnel.last_id"
                  :key="funnel.last_id">{{
                  funnel.title
                }}
              </option>



            </select>


          </div>
          <div class="form-group" v-if="newLead.funnel_id">
            <label for="exampleCategoryitem">Статус </label>
            <select id="exampleCategoryitem" v-model="newLead.status_id" required
                class="form-control">

              <option  v-for="status in statuses" :value="status.last_id"
                  :key="status.last_id" v-if="status.funnel_id==newLead.funnel_id">{{
                  status.title
                }}
              </option>



            </select>


          </div>
          <div  v-if="fields.length>0">
            <div class="form-group"  v-if="fields.length>0" v-for="field in fields"
                :key="field.last_id">
              <label for="exampleDateStart" v-if="!(field.type=='image' || field.type=='file')">{{ field.title}} </label>

              <input type="text" v-if="field.type=='string' || field.type=='phone' || field.type=='email' || field.type=='vk' "  class="form-control" :name="field.name" v-model="newLead.fields_value[field.name]"
              />
              <input type="number" v-if="field.type=='integer'"  class="form-control" v-model="newLead.fields_value[field.name]"
              />
              <textarea class="form-control textarea_add_lead" v-if="field.type=='textarea'" v-model="newLead.fields_value[field.name]"></textarea>
              <input type="text" v-if="field.type=='stroka'" class="form-control" v-model="newLead.fields_value[field.name]"/>
              <select  multiple="multiple" v-if="field.type=='multi'" class="form-control" v-model="newLead.fields_value[field.name]">
                <option v-if="field.options.length>0" v-for="(option,index) in field.options"
                    :key="index" :value="option">{{ option}}</option>
              </select>
              <select    v-if="field.type=='select'" class="form-control" v-model="newLead.fields_value[field.name]">
                <option v-if="field.options.length>0" v-for="(option,index) in field.options"
                    :key="index" :value="option">{{ option}}</option>
              </select>

            </div>

          </div>
          <div class="alert alert-danger" v-if="iserror==true">
            <p>{{ error_message }}</p>
          </div>
          <base-button  @click="onSave"  >Добавить сделку</base-button>
        </div>
      </div>
      </div>
    </div>
  </section>
</template>

<script>
import Api from "@/models/Api";
import LoadingBlock from "@/components/Custom/LoadingBlock";
import Editorjsrender from "../../models/Editorjsrender";
export default {
  name: "AddLead",

  data() {
    var app = this;

    return {
      'is_load':false,
      'newLead':{
        'category':null,
        'status_id':null,
        'funnel_id':null,
        'fields_value':{}
      },
      'statuses':null,
      'funnel':null,
      'funnels':null,
      'fields':null,
      'iserror':false,
      'is_load_error':false,
      'load_error':'',
      'error_message':'',
      'categorys':[],
    }
  },
  mounted: function () {
    var app = this;

    let id = app.$route.params.id;

    Api.loadCRMLeadField(function(data){
    //  app.funnel=data.funnel;
      app.fields=data.fields;
      app.statuses=data.statuses;
      app.funnels=data.funnels;
      app.is_load=true;
      //app.newLead.funnel_id=app.funnel.last_id;


    },function(err_message){
       app.is_load_error=true;
       app.load_error=err_message;
    });



  },
  methods:{
    onSave(){
      var app=this;
      app.is_load=false;
      var custom_fields=app.newLead.fields_value;
      var funnel_id=app.newLead.funnel_id;
      var category_id=app.newLead.category;
      var json_request={
        "category":category_id,
        "funnel_id":funnel_id,
        'status_id':app.newLead.status_id,
        "lead_data":custom_fields,
        'show_error':1,
        "json":{
          "blocks":[
            {
              "type": "header",
              "data": {
                "text": "Безымянный проект",
                "level": 2
              }
            },
            {
              "type" : "paragraph",
              "data" : {
                "text" : "Без какого либо описания",
              }
            }
          ]
        }
      };
      Api.addLead(json_request,function(data){

        app.is_load=true;
        app.iserror = false;

        app.$router.push({name: 'lead', params: {id: data.lead_id, "rand": Math.random()}});

      },function(error){
        app.is_load=true;
        app.iserror = true;
        app.error_message = error;
      });
    },
  },
  components: {

    LoadingBlock,
  }
}
</script>

<style scoped>

</style>